const ATM_PSI = 14.6959;
const KPA_PER_PSI = 6.89476;
const IN3_PER_FT3 = 1728;
const LITERS_PER_FT3 = 28.3168;
const CO2_DENSITY_LB_PER_FT3 = 0.1144; // density of CO2 gas near 70°F at 1 atm

const tabs = document.querySelectorAll('.tab');
const panels = document.querySelectorAll('.panel');
const imperialForm = document.getElementById('imperial-form');
const metricForm = document.getElementById('metric-form');
const imperialResults = document.getElementById('imperial-results');
const metricResults = document.getElementById('metric-results');

function setActiveTab(tabId) {
  tabs.forEach((tab) => {
    const isActive = tab.id === tabId;
    tab.classList.toggle('tab--active', isActive);
    tab.setAttribute('aria-selected', String(isActive));
  });

  panels.forEach((panel) => {
    const matches = panel.getAttribute('aria-labelledby') === tabId;
    panel.classList.toggle('panel--active', matches);
  });
}

tabs.forEach((tab) => {
  tab.addEventListener('click', () => setActiveTab(tab.id));
});

function formatNumber(value, decimals = 2) {
  return Number.isFinite(value) ? value.toFixed(decimals) : '—';
}

function cylinderVolume(diameterIn, widthIn) {
  const radius = diameterIn / 2;
  return Math.PI * radius * radius * widthIn; // cubic inches
}

function calculateVolumes({ outerDiameter, width, wheelDiameter }) {
  const outerVolumeIn3 = cylinderVolume(outerDiameter, width);
  const wheelVolumeIn3 = cylinderVolume(wheelDiameter, width);
  const airVolumeIn3 = Math.max(outerVolumeIn3 - wheelVolumeIn3, 0);
  const airVolumeFt3 = airVolumeIn3 / IN3_PER_FT3;

  return { airVolumeFt3 };
}

function gasUsage(airVolumeFt3, startPsi, targetPsi) {
  const deltaPsi = Math.max(targetPsi - startPsi, 0);

  if (deltaPsi === 0 || airVolumeFt3 === 0) {
    return { gasLbs: 0 };
  }

  const startAbs = startPsi + ATM_PSI;
  const targetAbs = targetPsi + ATM_PSI;

  const gasPerFillLb = ((targetAbs - startAbs) / ATM_PSI) * airVolumeFt3 * CO2_DENSITY_LB_PER_FT3;

  return { gasLbs: gasPerFillLb };
}

function fillResults(container, { airVolumeFt3, gasLbsPerFill, fills }) {
  const liters = airVolumeFt3 * LITERS_PER_FT3;
  const displayFills = Number.isFinite(fills)
    ? `${fills.toFixed(2)}`
    : 'Unlimited (no pressure change)';

  container.innerHTML = `
    <div class="result-row">
      <span class="result-label">Air cavity volume</span>
      <span class="result-value">${formatNumber(airVolumeFt3, 3)} ft³ / ${formatNumber(liters, 1)} L</span>
    </div>
    <div class="result-row">
      <span class="result-label">CO2 needed per fill</span>
      <span class="result-value">${formatNumber(gasLbsPerFill, 3)} lbs</span>
    </div>
    <div class="result-row">
      <span class="result-label">Estimated number of fills</span>
      <span class="result-value">${displayFills}</span>
    </div>
  `;
}

function calculateImperial(event) {
  event.preventDefault();
  const data = new FormData(imperialForm);

  const outerDiameter = Number(data.get('tireDiameter'));
  const width = Number(data.get('tireWidth'));
  const wheelDiameter = Number(data.get('wheelDiameter'));
  const startPsi = Number(data.get('startPsi'));
  const targetPsi = Number(data.get('targetPsi'));
  const co2Lbs = Number(data.get('co2Lbs'));

  const { airVolumeFt3 } = calculateVolumes({ outerDiameter, width, wheelDiameter });
  const { gasLbs } = gasUsage(airVolumeFt3, startPsi, targetPsi);
  const estimatedFills = gasLbs > 0 ? co2Lbs / gasLbs : Infinity;

  fillResults(imperialResults, {
    airVolumeFt3,
    gasLbsPerFill: gasLbs,
    fills: estimatedFills,
  });
}

function calculateMetric(event) {
  event.preventDefault();
  const data = new FormData(metricForm);

  const widthMm = Number(data.get('tireWidthMm'));
  const aspectRatio = Number(data.get('aspectRatio'));
  const wheelDiameter = Number(data.get('wheelDiameter'));
  const startPsi = Number(data.get('startKpa')) / KPA_PER_PSI;
  const targetPsi = Number(data.get('targetKpa')) / KPA_PER_PSI;
  const co2Lbs = Number(data.get('co2Lbs'));

  const widthIn = widthMm / 25.4;
  const sidewallHeightIn = widthIn * (aspectRatio / 100);
  const outerDiameter = wheelDiameter + sidewallHeightIn * 2;

  const { airVolumeFt3 } = calculateVolumes({ outerDiameter, width: widthIn, wheelDiameter });
  const { gasLbs } = gasUsage(airVolumeFt3, startPsi, targetPsi);
  const estimatedFills = gasLbs > 0 ? co2Lbs / gasLbs : Infinity;

  fillResults(metricResults, {
    airVolumeFt3,
    gasLbsPerFill: gasLbs,
    fills: estimatedFills,
  });
}

imperialForm.addEventListener('submit', calculateImperial);
metricForm.addEventListener('submit', calculateMetric);

// Run initial calculations with default values for quick feedback
document.addEventListener('DOMContentLoaded', () => {
  calculateImperial(new Event('submit'));
  calculateMetric(new Event('submit'));
  setActiveTab('imperial-tab');
});